import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { HelpCenterGroup, MutatorTx, Schema } from "../schema"
import type {
	CreateValue,
	HelpCenterGroupPortalMove,
	HelpCenterGroupReorder,
} from "../types"
import type { DeleteID, UpdateValue } from "@rocicorp/zero"

export const helpCenterGroupMutators = {
	create: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: CreateValue<HelpCenterGroup>
			ctx: ZeroJwtPayload
		}) => {
			await tx.mutate.helpCenterGroups.insert({
				...args,
				workspaceId: authData.workspaceId,
				version: 1,
			})
		},
	),
	update: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: UpdateValue<Schema["tables"]["helpCenterGroups"]>
		}) => {
			await tx.mutate.helpCenterGroups.update(args)
		},
	),
	delete: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: DeleteID<Schema["tables"]["helpCenterGroups"]>
		}) => {
			await tx.mutate.helpCenterGroups.delete({ id: args.id })
		},
	),
	moveToPortal: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: HelpCenterGroupPortalMove
		}) => {
			const articles = await tx.query.helpCenterArticles
				.where("helpCenterGroupId", "=", args.id)
				.run()

			await tx.mutate.helpCenterGroups.update({
				id: args.id,
				portalInstanceId: args.portalInstanceId,
			})

			for (const article of articles) {
				await tx.mutate.helpCenterArticles.update({
					id: article.id,
					portalInstanceId: args.portalInstanceId,
					updatedAt: Date.now(),
				})
			}
		},
	),
	// TODO: Use fractional indexing instead of numeric order for better concurrent reordering.
	// See: https://www.npmjs.com/package/fractional-indexing
	reorder: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: HelpCenterGroupReorder }) => {
			for (const item of args.items) {
				await tx.mutate.helpCenterGroups.update({
					id: item.id,
					order: item.order,
				})
			}
		},
	),
}
